import { useCallback, useState } from "react";

export interface TableSort<TSortBy extends string> {
  sortBy: TSortBy;
  sortAscending: boolean;
  /** Sorts by the given column; re-selecting the active column flips the direction. */
  setSort: (sortBy: TSortBy) => void;
}

/**
 * Sort state for a table whose columns are click-to-sort. A new column starts ascending,
 * which is what "alfabetisk" means for the text columns these tables lead with.
 */
export const useTableSort = <TSortBy extends string>(
  defaultSortBy: TSortBy,
  defaultAscending = true
): TableSort<TSortBy> => {
  const [sortBy, setSortBy] = useState<TSortBy>(defaultSortBy);
  const [sortAscending, setSortAscending] = useState(defaultAscending);

  const setSort = useCallback(
    (nextSortBy: TSortBy) => {
      setSortBy((currentSortBy) => {
        setSortAscending((ascending) =>
          nextSortBy === currentSortBy ? !ascending : true
        );
        return nextSortBy;
      });
    },
    []
  );

  return { sortBy, sortAscending, setSort };
};
